var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#265767"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.75 4.5C7.785 4.5 6.1875 6.0975 6.1875 8.0625C6.1875 9.99 7.695 11.55 9.66 11.6175C9.72 11.61 9.78 11.61 9.825 11.6175C9.84 11.6175 9.8475 11.6175 9.8625 11.6175C9.87 11.6175 9.87 11.6175 9.8775 11.6175C11.7975 11.55 13.305 9.99 13.3125 8.0625C13.3125 6.0975 11.715 4.5 9.75 4.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5607 13.6127C11.4682 12.2177 8.0557 12.2177 5.9482 13.6127C4.9957 14.2502 4.4707 15.1127 4.4707 16.0352C4.4707 16.9577 4.9957 17.8127 5.9407 18.4427C6.9907 19.1477 8.3707 19.5002 9.7507 19.5002C11.1307 19.5002 12.5107 19.1477 13.5607 18.4427C14.5057 17.8052 15.0307 16.9502 15.0307 16.0202C15.0232 15.0977 14.5057 14.2427 13.5607 13.6127Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.992 8.50459C18.112 9.95959 17.077 11.2346 15.6445 11.4071C15.637 11.4071 15.637 11.4071 15.6295 11.4071H15.607C15.562 11.4071 15.517 11.4071 15.4795 11.4221C14.752 11.4596 14.0845 11.2271 13.582 10.7996C14.3545 10.1096 14.797 9.07459 14.707 7.94959C14.6545 7.34209 14.4445 6.78709 14.1295 6.31459C14.4145 6.17209 14.7445 6.08209 15.082 6.05209C16.552 5.92459 17.8645 7.01959 17.992 8.50459Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4922 15.4428C19.4322 16.1703 18.9672 16.8003 18.1872 17.2278C17.4372 17.6403 16.4922 17.8353 15.5547 17.8128C16.0947 17.3253 16.4097 16.7178 16.4697 16.0728C16.5447 15.1428 16.1022 14.2503 15.2172 13.5378C14.7147 13.1403 14.1297 12.8253 13.4922 12.5928C15.1497 12.1128 17.2347 12.4353 18.5172 13.4703C19.2072 14.0253 19.5597 14.7228 19.4922 15.4428Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerCancel);
export default __webpack_public_path__ + "static/media/customer_cancel.a8c8696523b218380862dede982dfdae.svg";
export { ForwardRef as ReactComponent };